<template>
  <!-- <div :ref="divName" :id="divName"></div> -->
  <div class="vimeo-wrapper">
    <iframe :src="url" :id="divName" frameborder="0" width="100%" height="100%" allowfullscreen title="false" allow="autoplay; encrypted-media"></iframe>
  </div>

</template>

<script>
import Player from '@vimeo/player'
export default {
  name: 'VimeoPlayer',
  components: {
  },
  data () {
    return {
      isLoaded: false,
      url: `https://player.vimeo.com/video/${this.id}?responsive=1&title=0`,
      options: {
        id: this.id,
        responsive: true,
        title: false
      }
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    divName: {
      type: String,
      required: true
    }
  },
  mounted () {
    // const player = new Player(this.divName, this.options)
    // player.ready().then(() => {
    //   // the player is ready
    //   this.isLoaded = true
    // })
    const namePlayer = `player${this.options.id}`
    this[namePlayer] = new Player(this.divName, this.options)
    this[namePlayer].ready().then(() => {
      this.isLoaded = true
    })
  }
}
</script>

<style scoped>
.vimeo-wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  height: 300px;
}
</style>
